const AccessibilityReadingMaskHeightEnum = {
	"accessibility-reading-mask-height-1": "Petite hauteur",
	"accessibility-reading-mask-height-2": "Moyenne hauteur",
	"accessibility-reading-mask-height-3": "Grande hauteur"
} as const;

export default AccessibilityReadingMaskHeightEnum;

export const ReadingMaskHeightValues: Record<keyof typeof AccessibilityReadingMaskHeightEnum, number> = {
	"accessibility-reading-mask-height-1": 70,
	"accessibility-reading-mask-height-2": 130,
	"accessibility-reading-mask-height-3": 190
};
